module.exports = __webpack_public_path__ + "static/šest-guba-čarolija-i-jedan-užas-na-kvadrat-2881859b737864e89b37db2f9e0ceb2d.png";